module.exports = __webpack_public_path__ + "img/ts14.b663f094.png";